import { Service } from "../service.js";
import { env } from "../env.js";

class DepartamentoPadraoService extends Service {
  constructor() {
    super();

    this.url = `${env.url}departamento-padrao`;
  }

  async listar() {
    let departamentosPadroes = await super.get(this.url);

    return departamentosPadroes.map((departamento) => {
      return {
        value: "P" + departamento.id,
        label: departamento.nome,
      };
    });
  }
}

export const departamentoPadraoService = new DepartamentoPadraoService();
